import type { UserInfo } from '@vben/types'

import type { UserApi } from './types'

import { swaggerAuthClient } from '#/api/swagger-auth'

import { defineApi } from '../../define-api'

export const userApi = defineApi('/user', ({ prefix }) => {
  async function getUserInfo() {
    return swaggerAuthClient
      .get(prefix('getUserInfo'))
      .then((res) => res as UserApi.GetUserInfoResponse)
      .then(({ userInfo }): UserInfo => {
        return {
          token: '',
          avatar: userInfo.headerImg ?? '',
          desc: '',
          homePath: '',
          realName: userInfo.nickName ?? '',
          userId: userInfo.uuid ?? '',
          username: userInfo.userName ?? '',
          email: userInfo.email ?? '',
        }
      })
  }
  async function userSearchList(params: UserApi.UserSearchListParams) {
    return swaggerAuthClient.get(prefix('search') as any, params as any)
  }

  return {
    getUserInfo,
    userSearchList,
  }
})
